export default __webpack_public_path__ + "static/media/WhastappLogo.1dd8ca27.png";